// 🔴 LIVE PINS — pulsing red markers wherever a POG LIVE stream is happening right now.
import { useEffect } from "react";
import axios from "axios";
import L from "leaflet";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ensureCss = () => {
  if (document.getElementById("pog-live-pin-css")) return;
  const s = document.createElement("style");
  s.id = "pog-live-pin-css";
  s.textContent = `
    @keyframes pogLivePulse { 0%{box-shadow:0 0 0 0 rgba(239,68,68,.65)} 70%{box-shadow:0 0 0 14px rgba(239,68,68,0)} 100%{box-shadow:0 0 0 0 rgba(239,68,68,0)} }
    .pog-live-pin{animation:pogLivePulse 1.6s ease-out infinite;border-radius:9999px}`;
  document.head.appendChild(s);
};

const liveIcon = (title) => L.divIcon({
  className: "",
  iconSize: [86, 26],
  iconAnchor: [43, 13],
  html: `<div class="pog-live-pin" style="display:flex;align-items:center;gap:5px;background:rgba(15,23,42,.92);border:2px solid #EF4444;border-radius:9999px;padding:3px 9px 3px 7px;width:max-content;">
    <span style="width:8px;height:8px;border-radius:50%;background:#EF4444;display:inline-block;"></span>
    <span style="color:#fff;font-weight:900;font-size:10px;letter-spacing:.06em;white-space:nowrap;">LIVE · ${(title || "POG LIVE").slice(0, 16).replace(/</g, "")}</span>
  </div>`,
});

export function useLivePins(mapRef, navigate) {
  useEffect(() => {
    ensureCss();
    let layer = null;
    let stop = false;
    const refresh = async () => {
      try {
        const { data } = await axios.get(`${API}/live`);
        if (stop || !mapRef.current) return;
        if (layer) { layer.remove(); layer = null; }
        const lives = (data.lives || []).filter((l) => l.lat && l.lng);
        if (!lives.length) return;
        layer = L.layerGroup();
        lives.forEach((l) => {
          const m = L.marker([l.lat, l.lng], { icon: liveIcon(l.title), zIndexOffset: 1200 });
          m.on("click", () => navigate(`/live/${l.id}`));
          layer.addLayer(m);
        });
        layer.addTo(mapRef.current);
      } catch { /* radar silent */ }
    };
    refresh();
    const t = setInterval(refresh, 60000);
    return () => { stop = true; clearInterval(t); if (layer) layer.remove(); };
  }, []); // eslint-disable-line
}
